import axios from "@/api/axiosInstance";
import {
  FetchTransactionHistoryReportParams,
  FetchTransactionHistoryReportResponse,
} from "./types";

export const fetchTransactionHistoryReport = async (
  params: FetchTransactionHistoryReportParams = {},
): Promise<FetchTransactionHistoryReportResponse> => {
  const response = await axios.get<FetchTransactionHistoryReportResponse>(
    "/api/private/reports/transaction-history",
    { params },
  );
  return response.data;
};
